import { render, staticRenderFns } from "./comparacionFecha.vue?vue&type=template&id=3c6ead53&"
import script from "./comparacionFecha.vue?vue&type=script&lang=js&"
export * from "./comparacionFecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports